export const themeOptionFactory = (theme) => ({
  components: {
    EmKidAndFamilyPage: {
      styleOverrides: {
        container: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          height: "100%",
          backgroundColor: "#F2F2F2",
        },
        title: {
          fontWeight: 700,
          fontSize: "20px",
          marginBottom: theme.spacing(3),
        },
        sectionContentWrapper: {
          height: "100%",
        },
        occupantsSection: {
          position: "relative",
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            left: 0,
            right: 0,
            bottom: -20,
            minHeight: "120px",
            background:
              "linear-gradient(0deg, #FFF 37.46%, rgba(255, 255, 255, 0.00) 94.07%)",
          },
        },
        occupantCardsContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "dense",
          gridTemplateColumns: "repeat(4,  minmax(100px,1fr))",
          gap: theme.spacing(2),
          height: "100%",
          paddingBottom: theme.spacing(9.5),
          overflowY: "auto",
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          flex: "1",
        },
        eventPromotionSection: {
          position: "relative",
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            height: "100%",
            width: 120,
            background:
              "linear-gradient(-90deg, #FFF 37.46%, rgba(255, 255, 255, 0.00) 94.07%)",
          },
        },
        eventPromotionCardsContainer: {
          paddingRight: theme.spacing(9),
          display: "flex",
          gap: theme.spacing(5),
          overflowX: "scroll",
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "& > *": {
            flex: "0 0 200px",
          },
        },
      },
    },
  },
})
